<ng-content select="[sbInputIconPrefix]"></ng-content>
<sb-input-icon-prefix *ngIf="icon" aria-hidden="true">
  <sb-icon [name]="icon!"></sb-icon>
</sb-input-icon-prefix>
<ng-content></ng-content>
<ng-content select="[sbInputIconSuffix]"></ng-content>
